import type { DeprecatedModalTokens } from './types';

export const deprecatedModal: DeprecatedModalTokens = {
  colors: {
    background: 'rgba(0,0,0,0.8)',
  },
};
